var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.url)?_c('video',{ref:"video-player",staticClass:"video-js vjs-default-skin vjs-big-play-centered",attrs:{"controls":""},on:{"playing":_vm.onPlay,"pause":_vm.onPause}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }